import Vue from 'vue'
import Vuex from 'vuex'
import VueRouter from 'vue-router'

import KeyboardWrapper from '@/components/accessibility/KeyboardWrapper'

import activities from '@/store/activities'
import auth, { AuthStoreNamespacedTypes } from '@/store/auth'
import books from '@/store/books'
import homework from '@/store/homework'
import keyboard from '@/store/keyboard'
import levels from '@/store/levels'
import lessons from '@/store/lessons'
import pdfAssignments from '@/store/pdf-assignments'
import questions from '@/store/questions'
import topics from '@/store/topics'

import { createRouter } from '@/routers/books'

import { UserType } from '@/enums'

import { generateVueOptions } from './base'

import { getRouteStructure } from '@/utils/routing'
import { edulabGlobalPromise } from '@/utils/scripts'

const config = generateVueOptions()

Vue.use(VueRouter)
Vue.use(Vuex)

const store = new Vuex.Store({
  modules: {
    activities,
    auth,
    books,
    homework,
    keyboard,
    levels,
    lessons,
    pdfAssignments,
    questions,
    topics,
  },
})

const router = createRouter(store)

new Vue({
  ...config,
  store,
  router,
  data() {
    return {
      ...config.data(),
      books: [],
      levelIntervals: [],
      levelsData: [],
      errors: [],
    }
  },
  computed: {
    pageTitle() {
      const routes = getRouteStructure(this.$router, this.$route)

      return routes
        .map(({ name, route }) =>
          typeof name === 'function' ? name(route) : name
        )
        .filter(name => name && name !== '-')
        .reverse()
        .join(' - ')
    },
  },
  methods: {},
  watch: {
    pageTitle: {
      immediate: true,
      handler(pageTitle) {
        document.title = `${pageTitle} - ${this.$t('app.name')}`
      },
    },
  },
  render: createElement =>
    createElement(KeyboardWrapper, [createElement('RouterView')]),
  created() {
    this.$store.dispatch(
      AuthStoreNamespacedTypes.actions.SET_USER_TYPE,
      this.isTeacher ? UserType.TEACHER : UserType.STUDENT
    )
    this.$store.dispatch(
      AuthStoreNamespacedTypes.actions.SET_USER_CLASS,
      this.userClass
    )
    edulabGlobalPromise.then(() => {
      edulab.base.onReady(edulab.base.pageReady)
    })
  },
}).$mount('#vueApp')
